import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationState {
  application_status_data: string | number | Array;
  district_data: string | number | Array;
  drillDownDistrictCode: string | number | Array;
  drillDownTalukCode: string;
  drillDownVillageCode: string;
  loading: boolean;
  loader: boolean;
  pieChartId: string | number | Array;
  statusBarPopupId: string | number | Array;

  tableChartId: string | number | Array;
  tableHeading: string | number | Array;
  talukCode: string;
}
const initialState: ApplicationState = {
  application_status_data: [1],
  loading: false,
  loader: false,
  drillDownDistrictCode: "",
  drillDownTalukCode: "",
  drillDownVillageCode: "",
  pieChartId: "",
  tableChartId: "",
  tableHeading: "",
  talukCode: "",
};

const applicationStatusSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setApplicationStatus: (state, action: PayloadAction<string | number>) => {
      state.application_status_data = action.payload;
    },

    setLoading: (state, action: PayloadAction<string | number>) => {
      state.loading = action.payload;
    },
    setLoader: (state, action: PayloadAction<string | number>) => {
      state.loader = action.payload;
    },

    setDrillDownDistrictCode: (
      state,
      action: PayloadAction<string | number>
    ) => {
      state.drillDownDistrictCode = action.payload;
    },
    setPidChartId: (state, action: PayloadAction<string | number>) => {
      state.pieChartId = action.payload;
    },

    setStatusBarPopupId: (state, action: PayloadAction<string | number>) => {
      state.statusBarPopupId = action.payload;
    },
    setTableChartId: (state, action: PayloadAction<string | number>) => {
      state.tableChartId = action.payload;
    },
    setTableHeading: (state, action: PayloadAction<string | number>) => {
      state[action.payload.id] = action.payload;
    },

    setTalukCode: (state, action: PayloadAction<string | number>) => {
      state.talukCode = action.payload;
    },
    setDrillDownTalukCode: (state, action: PayloadAction<string>) => {
      state.drillDownTalukCode = action.payload;
    },
    setDrillDownVillageCode: (state, action: PayloadAction<string>) => {
      state.drillDownVillageCode = action.payload;
    },
  },
});

export const {
  setApplicationStatus,
  setLoading,
  setLoader,
  setPidChartId,
  setDrillDownDistrictCode,
  setDrillDownTalukCode,
  setDrillDownVillageCode,
  setTableChartId,
  setTableHeading,
  setTalukCode,
  setStatusBarPopupId,
} = applicationStatusSlice.actions;
export default applicationStatusSlice.reducer;
